<template src="./summary-dim-select-image.html"></template>

<script lang="ts">
import { hostsConfig } from 'init/config'

export default {
  props: {
    values: {
      type: Array,
      default: () => []
    },
    headingLevel: { type: Number, default: 3 },
    label: { type: String }
  },
  methods: {
    imageUrl(imageId) {
      return `${hostsConfig.protocol}://${hostsConfig.imageStoreBase}/custom-dim/${hostsConfig.siteKey}/${imageId}.png`
    }
  }
}
</script>

<style lang="scss" src="./summary-dim.scss"></style>
<style lang="scss" src="./summary-dim-select-image.scss"></style>
